"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerTabs = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Calendar = _interopRequireDefault(require("../Calendar"));

var _Footer = _interopRequireDefault(require("../Footer"));

var _CloseButton = _interopRequireDefault(require("../../../CloseButton"));

var _usehooksTs = require("usehooks-ts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var DatePickerTabs = function DatePickerTabs(props) {
  var _props$isMobile = props.isMobile,
      isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
      open = props.open,
      leftValue = props.leftValue,
      rightValue = props.rightValue,
      closeCalendar = props.closeCalendar,
      onChangeCalendar = props.onChangeCalendar,
      onChangeShift = props.onChangeShift,
      currentShift = props.currentShift,
      applyButtonHandler = props.applyButtonHandler,
      minDate = props.minDate,
      isEndDateFocus = props.isEndDateFocus,
      _props$isWizard = props.isWizard,
      isWizard = _props$isWizard === void 0 ? false : _props$isWizard,
      isHotelOnly = props.isHotelOnly,
      searchCalendarDuration = props.searchCalendarDuration,
      indicationMap = props.indicationMap,
      directFlightsInfo = props.directFlightsInfo,
      setStartCurrentMonth = props.setStartCurrentMonth,
      isHotelVariant = props.isHotelVariant;
  var ref = (0, _react.useRef)(null); // хук который закрывает календарь (any потому что не смог нормально типизировать)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var handleClickOutside = isWizard ? function () {
    return null;
  } : closeCalendar;
  (0, _usehooksTs.useOnClickOutside)(ref, handleClickOutside);

  if (!open) {
    return null;
  }

  var startDate = leftValue.date;
  var endDate = rightValue.date; // показываем подсказку "Прямые перелеты" только если есть результат от ручки direct_flights

  var isShownDirectFlightsLegend = Object.values(directFlightsInfo).some(function (item) {
    return item.length > 0;
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledContainer, {
    $isMobile: isMobile,
    $isWizard: isWizard,
    ref: ref
  }, isMobile && !isWizard && /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement(StyledCloseButton, {
    onClick: closeCalendar
  })), /*#__PURE__*/_react["default"].createElement(_Calendar["default"], {
    open: open,
    closeCalendar: closeCalendar,
    startDate: startDate,
    endDate: endDate,
    onChange: onChangeCalendar,
    searchCalendarDuration: searchCalendarDuration,
    minDate: minDate,
    isMobile: isMobile,
    isWizard: isWizard,
    isEndDateFocus: isEndDateFocus,
    indicationMap: indicationMap,
    directFlightsInfo: directFlightsInfo,
    setStartCurrentMonth: setStartCurrentMonth,
    onClose: closeCalendar,
    isHotelOnly: isHotelOnly,
    isHotelVariant: isHotelVariant
  }), /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    isHotelVariant: isHotelVariant,
    isMobile: isMobile,
    applyButtonHandler: applyButtonHandler,
    leftValue: leftValue,
    rightValue: rightValue,
    isHotelOnly: isHotelOnly,
    currentShift: currentShift,
    isShownDirectFlightsLegend: isShownDirectFlightsLegend,
    onChangeShift: onChangeShift
  })));
};

exports.DatePickerTabs = DatePickerTabs;

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "DatePickerTabs__StyledContainer",
  componentId: "sc-1j05j4e-0"
})(["pointer-events:auto;display:flex;flex-direction:column;align-items:center;", " padding:", ";font-family:inherit !important;font-size:14px;line-height:16px;border:none;display:flex;flex-direction:column;width:100%;align-items:center;background-color:#fff;", " ", " ", ";", " z-index:11001;"], function (_ref) {
  var $isMobile = _ref.$isMobile;
  return $isMobile && 'width: 100%;';
}, function (_ref2) {
  var $isMobile = _ref2.$isMobile,
      $isWizard = _ref2.$isWizard;
  return $isMobile && !$isWizard ? '72px 0 64px' : '16px 0 64px';
}, function (_ref3) {
  var $isMobile = _ref3.$isMobile,
      $isWizard = _ref3.$isWizard;
  return $isMobile && !$isWizard && "\n      top: 60px;\n      position: fixed;\n      left: 0;\n      z-index: 120;\n      height: 100vh;\n    ";
}, function (_ref4) {
  var $isWizard = _ref4.$isWizard;
  return $isWizard && "\n      height: 100vh;\n    ";
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile;
  return !$isMobile && "\n      position: absolute;\n      width: auto;\n      margin-top: 56px;\n      border-radius: var(--border-radius);\n      left: 50%;\n      transform: translate(-50%, 0);\n\n      z-index: 999;\n      padding-bottom: 16px;\n      box-shadow: 0 2px 4px rgb(210 208 197 / 80%);\n    ";
}, function (_ref6) {
  var $isMobile = _ref6.$isMobile,
      $isWizard = _ref6.$isWizard;
  return $isMobile && "\n      ".concat(!$isWizard && "width: 100%;", "\n      display: flex;\n      justify-content: center;\n      overflow-y: scroll;\n  ");
}); // @todo
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore


var StyledCloseButton = (0, _styledComponents["default"])(_CloseButton["default"]).attrs({
  $inMobileInput: true
}).withConfig({
  displayName: "DatePickerTabs__StyledCloseButton",
  componentId: "sc-1j05j4e-1"
})(["position:fixed;top:20px;margin:0 16px 0 0;"]);

var Header = _styledComponents["default"].div.withConfig({
  displayName: "DatePickerTabs__Header",
  componentId: "sc-1j05j4e-2"
})(["position:fixed;height:64px;background-color:var(--primary-header);width:100%;margin-bottom:16px;z-index:120;top:0;"]);